import get from 'lodash/get';
import { connect } from 'react-redux';
import { withGetCompanyData } from 'src/_shared/api/components/settings/';
import {
	dashboardActions,
	navigationActions,
	referralActions,
	userActions,
} from 'src/actions.js';
import { compose } from 'src/_shared/services/utils';
import { CustomizableAsideComponent } from 'src/customizable-ui/aside/CustomizableAsideComponent.jsx';

const mapStateToProperties = (state) => {
	const {
		navigation,
		user: { currentUser },
	} = state;
	const { allMultiLingualData } = state.dashboard;
	return {
		id: get(currentUser, 'id'),
		currentUser,
		currentLocation: navigation.currentLocation,
		companyId: get(currentUser, 'companyId'),
		allMultiLingualData,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		resetReferral() {
			dispatch(referralActions.resetReferral());
		},
		updatePathname(pathname) {
			dispatch(navigationActions.createUpdatePathname(pathname));
		},
		setCurrentUser(user) {
			dispatch(userActions.createSetCurrentUserAction(user));
		},
		setMultiLingualData(data) {
			dispatch(dashboardActions.createSetMultiLingualData(data));
		},
		updateDisplay(role) {
			dispatch(userActions.updateDisplayAs(role));
		},
		updateFeatureFlags(featureFlags) {
			dispatch(userActions.updateFeatureFlags(featureFlags));
		},
	};
};

export const CustomizableAsideApi = compose(withGetCompanyData)(
	CustomizableAsideComponent
);

export const CustomizableAside = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(CustomizableAsideApi);
